export abstract class State {
  abstract getSpeed(): number;
}
